export const formatoPrecio = (precio) => {
  return new Intl.NumberFormat("es-AR", {
    style: "currency",
    currency: "ARS",
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(precio);
};

export const calcularDescuento = (precio, descuento) => {
  const precioConDescuento = precio - (precio * descuento) / 100;
  return formatoPrecio(precioConDescuento);
};

export const calcularDescuentoNumero = (precio, descuento) => {
  return precio - (precio * descuento) / 100;
};
